import { render } from "./App.vue?vue&type=template&id=4d76a898"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4d76a898&lang=scss"

import exportComponent from "D:\\ProjectDocuments\\pixlBluetooth\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__